import { useId, useRef } from "react";
import { C } from "./theme";
import { hue } from "./hue";
import { BottomSheet } from "./BottomSheet";
import { ADD_KINDS } from "./addKinds";
import { KindIcon } from "./kindIcons";

// What + in the top bar opens on every page: one row for each kind of thing you can add, in Home's order,
// each with its Home tile's icon and hue. onPick(kind) gets an entry of ADD_KINDS.
export function AddSheet({ onPick, onClose }) {
  const titleId = useId();
  const firstRef = useRef(null);
  return (
    <BottomSheet labelledBy={titleId} startRef={firstRef} onClose={onClose}>
      <h2 id={titleId} style={{ margin: "0 0 10px", fontSize: 17, fontWeight: 700 }}>Add new</h2>
      <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: 6 }}>
        {ADD_KINDS.map((kind, i) => {
          return <li key={kind.id}><AddKindRow kind={kind} buttonRef={i === 0 ? firstRef : undefined} onClick={() => onPick(kind)} /></li>;
        })}
      </ul>
    </BottomSheet>
  );
}

// One kind's row: its Home tile's icon in its hue, its name and line, and ›. The Goal page's habit picker starts with
// the same row for a new habit. `title` replaces the kind's name where the row says more ("New habit").
export function AddKindRow({ kind, title = kind.title, buttonRef, onClick }) {
  const h = hue(kind.hueName);
  return (
    <button ref={buttonRef} onClick={onClick}
      style={{ width: "100%", minHeight: 52, display: "flex", alignItems: "center", gap: 12, padding: "6px 12px", background: C.surface2, border: `1px solid ${C.border}`, borderRadius: C.r, cursor: "pointer", fontFamily: "inherit", textAlign: "left", color: C.text }}>
      <span aria-hidden="true" style={{ width: 38, height: 38, flexShrink: 0, borderRadius: 10, display: "grid", placeItems: "center", background: `color-mix(in srgb, ${h.b} 45%, ${C.surface})`, color: h.c }}>
        <KindIcon id={kind.tile} size={20} />
      </span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: "block", fontSize: 16, fontWeight: 700, lineHeight: 1.25 }}>{title}</span>
        <span style={{ display: "block", fontSize: 14, lineHeight: 1.35, color: C.textMid }}>{kind.line}</span>
      </span>
      <span aria-hidden="true" style={{ flexShrink: 0, color: C.textDim, fontSize: 20, lineHeight: 1 }}>›</span>
    </button>
  );
}
